





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { VoucherItem } from '@/types/voucher';
import { getBgColor } from '@/business/voucher';
import { i18n } from '@/i18n';

@Component
export default class Voucher extends Vue {
  @Prop({ required: true }) public voucher!: VoucherItem;
  @Prop({ required: true }) public isInvalidCoupon?: boolean;

  private get bgColor() {
    if (!this.voucher) {
      return '';
    }
    return {
      'background-color': getBgColor(this.voucher),
    };
  }

  private get displayTimeTxt() {
    return  this.isInvalidCoupon ? i18n('已过期') : i18n('有效期至：') + this.voucher.expireTime;
  }
}
